import {
  PostLoanApplicationPayload,
  PostLoanApplicationResponse,
} from 'types/webApi';
import { ValidationError } from 'api/errors/ValidationError';
import postLoanApplicationApiCall from 'api/calls/postLoanApplicationApiCall';
import useProtectedMutation from './useProtectedMutation';

const usePostLoanApplicationMutation = () =>
  useProtectedMutation<
    PostLoanApplicationResponse,
    ValidationError[],
    PostLoanApplicationPayload,
    undefined
  >(postLoanApplicationApiCall);

export default usePostLoanApplicationMutation;
